import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const REVEAL_SELECTOR = "main section, footer";

const ScrollRevealController: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const elements = Array.from(
      document.querySelectorAll<HTMLElement>(REVEAL_SELECTOR)
    );

    if (!elements.length) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const assignRevealItems = (element: HTMLElement) => {
      const primaryContainer =
        element.querySelector<HTMLElement>(":scope > .site-container") ||
        element.querySelector<HTMLElement>(":scope > div > .site-container") ||
        element.firstElementChild;

      if (!(primaryContainer instanceof HTMLElement)) return;

      Array.from(primaryContainer.children).forEach((child, index) => {
        if (!(child instanceof HTMLElement)) return;

        child.classList.add("scroll-reveal-item");
        child.style.setProperty(
          "--reveal-delay",
          `${Math.min(index * 90, 360)}ms`
        );
      });
    };

    elements.forEach((element) => {
      element.classList.add("scroll-reveal");
      assignRevealItems(element);
    });

    if (prefersReducedMotion) {
      elements.forEach((element) => {
        element.classList.add("scroll-reveal-visible");
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scroll-reveal-visible");
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -12% 0px",
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [location.pathname]);

  return null;
};

export default ScrollRevealController;
